<template>
  <v-card style="background-color:transparent" flat @click.native="$router.push({name: 'HomePage'})">
    <v-card-text>

      <!-- Should a partner logo or a onechart logo be shown-->
      <v-layout row>
        <v-layout column justify-center>

          <div v-if="showLogo" style="margin: 0 auto;" class="logo">
            <img style="max-width:100%; margin-bottom:30px;" :src="showLogo" alt="">
          </div>

          <v-divider v-if="showLogo" v-show="!recordShare && !providerLanding" style="margin-bottom:10px;"></v-divider>
          <div style="margin: 0 auto;" class="logo">

            <img v-if="showLogo" v-show="!recordShare && !providerLanding" style="height:40px; max-width:100%; margin-bottom:20px;" :src="standardLogo" alt="">
            <img v-else style="max-width:100%" :src="standardLogo" alt="">

          </div>

          <v-layout v-if="loginDetailText" justify-center column>
            <span v-if="!recordShare && !providerLanding" style="font-size:18px; font-weight:300; text-align:center; margin-top:20px; margin-right:30px; margin-left:30px;">{{ loginDetailText }}</span>
            <span v-if="recordShare" style="font-size:18px; font-weight:700; text-align:center; margin-top:20px;">{{ loginDetailText }}</span>
            <span v-if="recordShare" style="font-size:14px; margin-top:5px; font-weight:300; text-align:center">Returning OneChart users may enter their credentials below. To maintain the privacy and confidentiality of the shared records, if this is your first time using the OneChart platform you must register before viewing the shared records.</span>

          </v-layout>

        </v-layout>
      </v-layout>

    </v-card-text>
  </v-card>
</template>

<style lang="scss" scoped>
$font: sans-serif;
$color: #1565c0;
$gender: #666;
$birthdate: #999;
$addr: #1565c0;
$background-gray: #eee;

.logoDetail {
  display: flex;
  align-items: center;
  font-size: 16px;
  color: 'primary';
  // padding: 10px 24px;
  border-radius: 8px;
  font-weight: 300;
}
.logo {
  display: flex;
  align-items: center;
  font-size: 28px;
  color: 'primary';
  // padding: 10px 24px;
  border-radius: 8px;
  text-transform: uppercase;
  cursor: pointer;
  letter-spacing: 7px;
  font-weight: 300;
  .logo-icon {
    margin-right: 5px;
    font-size: 40px;
  }
}

.contentDivider {
margin-top:20px;
margin-bottom:20px;
height:1px; 
width:100%; 
background-color:#DDDDDD
}
</style>
<script>
import Avatar from '@/core/components/Avatar'

export default {
  name: 'OnePatientCard',
  components: {
    Avatar
  },
  props: {
    recordShare: {
      type: Boolean,
      default: false
    },
    providerLanding: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    showLogo() {
      if (this.$subdomainPartner !== 'default') {
        return 'https://storage.googleapis.com/onechart-assets/logos/login/' + this.$subdomainPartner + '.png'
      } else {
        return null
      }
    },
    standardLogo() {
      return 'https://storage.googleapis.com/onechart-assets/logos/login/default_normalized.png'
    },
    loginDetailText() {
      if (this.providerLanding) {
        return false
      }
      if (this.recordShare) {
        return 'View Shared Records'
      } else {
        if (this.$subdomainPartner === '5a4fa82c8e4b74e028665d04') {
          return 'Login below to quickly access and share your Smart Choice MRI health records'
        } else if (this.$subdomainPartner === 'default') {
          return 'Securely store, access, and share your health information anywhere.'
        } else {
          return false
        }
      }
    }
  },
  methods: {
    textSwitch() {
      console.log('textSwitch')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/cards/LogoHeaderCard.vue